/* eslint-disable jsx-a11y/no-static-element-interactions */
/* eslint-disable jsx-a11y/click-events-have-key-events */
// import { StackedList } from '@/Components/UI/StackedList/StackedList';
import { Button } from '@/Components/UI/Button/Button';
import { useCurrentFile } from '@/hooks/useCurrentFile';
import clsx from 'clsx';
import { useEffect, useState } from 'react';

const defaultExamples = [
  'Show me rows where Company Name contains LLC, Corp, or Inc.',
  'What has the highest cost?',
  'Which product is most popular?',
  'What city has the highest income per capita?',
];

const SheetAssistantTipsSection = ({ disableSheetAssistant, applyExample }) => {
  const [examples, setExamples] = useState(defaultExamples);
  const currentFile = useCurrentFile();

  useEffect(() => {
    const exampleAnalyses = currentFile?.metadata?.ExampleAnalyses;
    if (exampleAnalyses && Array.isArray(exampleAnalyses) && exampleAnalyses.length > 0) {
      setExamples(exampleAnalyses);
    }
  }, [currentFile]);

  const isDefaultExample = (example) => !!defaultExamples.filter((i) => i === example).length;
  const handleApplyExample = (example) => {
    if (!isDefaultExample(example)) {
      applyExample(example);
    } else {
      return;
    }
  };
  const optionsFormat = examples.map((example) => {
    return {
      value: example,
      label: example,
      disabled: isDefaultExample(example),
      onClick: () => handleApplyExample(example),
    };
  });

  return (
    <div hidden={disableSheetAssistant} className='select-text text-ui-helper w-fit'>
      <div className='pb-2 pl-1 text-sm font-semibold text-ui-helper'>Examples</div>
      <div className='w-full'>
        <div className='flex flex-col gap-1 pb-5'>
          {optionsFormat.map((option) => {
            return (
              <div
                onClick={option.onClick}
                className={clsx(
                  'flex items-center justify-between w-full p-2  border rounded bg-shadow-100 bg-opacity-24 text-ui-secondary font',
                  !isDefaultExample && 'hover:bg-opacity-80 cursor-pointer'
                )}
                key={option.label}
              >
                <div className='w-10/12'>{option.label}</div>
                <Button
                  className={clsx(option.disabled && 'hidden')}
                  onClick={option.onClick}
                  iconName='caret-right'
                  size='small'
                  variant='ghost'
                  color='shadow'
                ></Button>
              </div>
            );
          })}
        </div>
      </div>
    </div>
  );
};

export default SheetAssistantTipsSection;
